
import { defineComponent } from "vue";

export default defineComponent({
  name: "Folder",
  props: {
    title: String,
    positionX: [Number, String],
    positionY: [Number, String],
    top: [Number, String],
    left: [Number, String],
    textColor: String,
    fontWeight: String
  },
  methods: {
    positionString() {
      const style = {
        ...(this.positionX &&
          this.positionY && {
            transform: `translate(${+this.positionX}%, ${+this.positionY}%)`
          }),
        ...(this.top && { top: `${this.top}%` }),
        ...(this.left && { left: `${this.left}%` })
      };
      return style;
    }
  }
});
